import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Button from './Button/Button';
import Input from './Input/Input';

function Departments({ reloadAll }) {
  const [departments, setDepartments] = useState([]);
  const [editingDepartment, setEditingDepartment] = useState(null);

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      const res = await api.getDepartments();
      setDepartments(res.data);
    } catch (error) {
      console.error('Error loading departments:', error);
    }
  };

  const handleUpdateDepartment = async (e) => {
    e.preventDefault();
    try {
      await api.updateDepartment(editingDepartment.id, editingDepartment);
      setEditingDepartment(null);
      loadDepartments();
      if (reloadAll) reloadAll();
    } catch (error) {
      console.error('Error updating department:', error);
    }
  };

  const handleDeleteDepartment = async (id) => {
    if (window.confirm('Are you sure you want to delete this department? This will affect all associated skills, levels, and team members.')) {
      try {
        await api.deleteDepartment(id);
        loadDepartments();
        if (reloadAll) reloadAll();
      } catch (error) {
        console.error('Error deleting department:', error);
      }
    }
  };

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {departments.map((department) => (
            <tr key={department.id}>
              <td>
                {editingDepartment?.id === department.id ? (
                  <Input
                    type="text"
                    value={editingDepartment.name}
                    onChange={(e) => setEditingDepartment({ ...editingDepartment, name: e.target.value })}
                    id={`edit-department-name-${department.id}`}
                  />
                ) : (
                  department.name
                )}
              </td>
              <td className="td--actions">
                {editingDepartment?.id === department.id ? (
                  <>
                    <Button type="primary" onClick={handleUpdateDepartment}>Save</Button>
                    <Button type="secondary" onClick={() => setEditingDepartment(null)}>Cancel</Button>
                  </>
                ) : (
                  <>
                    <Button type="secondary" onClick={() => setEditingDepartment(department)}>Edit</Button>
                    <Button type="destructive" onClick={() => handleDeleteDepartment(department.id)}>Delete</Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Departments; 